import { User } from '@frontend/user/utils';
import { useState } from 'react';
import { LuArrowLeft, LuHouse } from 'react-icons/lu';

import { useAppSelector } from '../redux/store';
import { useKioskNavigate } from '../utils/kiosk-navigation';
import { KioskUserModal } from './kiosk-user-modal.component';

const ID = 'kiosk-navigation-header';

interface KioskNavigationHeaderProps {
    title: React.ReactNode;
    onBack?: () => void;
    onHomeClick?: () => void;
}

export const KioskNavigationHeader = (props: KioskNavigationHeaderProps) => {
    const navigate = useKioskNavigate();
    const navigationState = useAppSelector((state) => state.navigation);
    const [isUserModalOpen, setIsUserModalOpen] = useState(false);

    return (
        <>
            <header
                id={ID}
                className='bg-background-surface border-border-default inline-flex items-start justify-start self-stretch border-b'>
                <div className='border-border-default flex flex-1 items-center justify-start gap-4 self-stretch border-r p-4'>
                    <div className='flex flex-1 items-center justify-start gap-2'>
                        <button
                            disabled={!props.onBack}
                            className={`text-foreground-default disabled:text-brand-disabled flex size-9 cursor-pointer items-center justify-center p-2`}
                            onClick={props.onBack}>
                            <LuArrowLeft size='100%' />
                        </button>
                        <h3 className='text-foreground-default justify-start text-lg font-semibold'>{props.title}</h3>
                    </div>
                    <div
                        className='flex size-9 cursor-pointer items-center justify-center p-2'
                        onClick={props.onHomeClick || (() => navigate('/'))}>
                        <LuHouse size='100%' />
                    </div>
                </div>
                {navigationState.user?.user && (
                    <div className='flex h-full w-20 items-center justify-center gap-2'>
                        <div
                            className='bg-brand-secondary flex size-9 cursor-pointer items-center justify-center gap-2.5 rounded-full'
                            onClick={() => setIsUserModalOpen(true)}
                            data-testid='user-initials-button'>
                            <div className='text-background-surface justify-start text-center text-base font-semibold'>
                                {new User(navigationState.user?.user).getInitials()}
                            </div>
                        </div>
                    </div>
                )}
            </header>
            <KioskUserModal
                show={isUserModalOpen}
                onClose={() => setIsUserModalOpen(false)}
            />
        </>
    );
};
